<template>
  <div
    class="topbar-profile dropdown"
    :class="{ show: isOpen }"
    aria-haspopup="true"
    :aria-expanded="isOpen"
    v-click-outside="closeDropDown"
  >
    <div
      class="navbar-profilepic"
      :style="`background-image: url(${
        me.img ? me.img : 'img/profile-img.png'
      })`"
      @click="toggleDropDown"
    ></div>

    <div
      class="dropdown-menu show p-3 dropdown-content"
      v-show="isOpen"
      style="left: -255px !important"
    >
      <b-row class="pb-4 justify-content-between text-small" no-gutters>
        <span class="">Henkel</span>
        <span class="pointer" @click="signOut()">{{
          $t("label.signOut")
        }}</span>
      </b-row>
      <b-row class="justify-content-center" no-gutters>
        <b-col cols="4">
          <div
            class="topbar-profile navbar-profilepic dropdown-toggle"
            :style="`background-image: url(${
              me.img ? me.img : 'img/profile-img.png'
            })`"
          ></div>
        </b-col>
        <b-col cols="8" class="text-small pl-2">
          <h6>{{ me.displayName }}</h6>
          <div class="py-1 text-long">{{ me.mail }}</div>
          <div class="pb-1">
            <a href="https://myaccount.microsoft.com/" target="_blank">{{
              $t("label.viewAccount")
            }}</a>
          </div>
          <div>
            <a href="https://apc.delve.office.com/" target="_blank">{{
              $t("label.myMicrosoft365Profile")
            }}</a>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { jwtHelper } from "@/core/utils";
export default {
  name: "base-dropdown",
  props: {
    title: String,
    icon: String,
    tag: {
      type: String,
      default: "li",
    },
  },
  data() {
    return {
      isOpen: false,
      me: jwtHelper.getProfile().profile,
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown() {
      this.isOpen = false;
    },
    signOut() {
      jwtHelper.removeToken();
      jwtHelper.removeLastActivityTime();
      jwtHelper.removeSessionExpirationTime();
      jwtHelper.removeProfile();
      window.location.replace(
        "https://login.microsoftonline.com/common/oauth2/v2.0/logout"
      );
    },
  },
};
</script>
<style scoped></style>
